// ONE ship-to OPTION renderer, shared by the two pickers that offer the
// location master: the Answers step (SmartAnswerInput's LocationSelect)
// and the Lines editor (LineItemsEditor's per-line ship-to cell).
// Extracted from SmartAnswerInput on 2026-08-23 - the markup below is that
// component's own, moved verbatim, not a second renderer written to look
// like it. The FieldError.jsx / CodeNameLabel.jsx precedent.
//
// Both pickers read the SAME payload: api.getLocations() -> GET /locations
// -> database.py's get_active_locations_from_db, whose returned shape is
// exactly {location_id, name, address} and whose docstring already names
// both of these components as consumers of it. The Lines editor was
// therefore already receiving the address and simply not rendering it.
//
// OPTION ONLY, NEVER THE TRIGGER. Radix mirrors a selected item's full
// rendered content into the trigger by default, which would pull the
// address in there too; both call sites override SelectValue's children to
// keep the closed control compact (CODE - Name). That rule was ruled on
// for the Answers step (UI POLISH, 2026-07-28 ruling, item 2) and is
// asserted on both sides.
//
// THE ADDRESS IS OPTIONAL BY DESIGN, not defensively. A location row may
// carry an empty location_address, and an unmatched code - one the buyer
// stored before the row was deactivated - has no master row at all and so
// no address to show. Rendering an empty second line, or the word
// "undefined", would be worse than rendering one line.
const LocationOptionLabel = ({ code, name, address }) => (
  <div className="flex flex-col py-1">
    <span className="font-medium">{code} - {name}</span>
    {address && (
      <span className="text-xs text-zinc-500">{address}</span>
    )}
  </div>
);

export default LocationOptionLabel;
